export class Overlay {
    private overlay: HTMLElement = document.querySelector("[data-overlay]") as HTMLElement;
    private body: HTMLElement = document.querySelector("body") as HTMLElement;
    private timeout: any = {};

    public ShowOverlay() {     
        this.body.classList.add("body2018--overlay-active");
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.overlay.classList.add("overlay--active");
        }, 100);
    }  

    public HideOverlay() {
        this.overlay.classList.remove("overlay--active");        
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.body.classList.remove("body2018--overlay-active");           
        }, 300);
    } 
}



// WEBPACK FOOTER //
// ./src/global/Overlay.ts